import { render, staticRenderFns } from "./SchoolPickerPrezydencki.vue?vue&type=template&id=fb756450&"
import script from "./SchoolPickerPrezydencki.vue?vue&type=script&lang=js&"
export * from "./SchoolPickerPrezydencki.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports